import Track from "../Track";
import {TTrack} from "../../types";
import styled from "styled-components";
import {storeTrack} from "../../services/store-track";
import {Message} from "../Message";

export type SearchTrackResultListProps = {
    tracks?: Array<TTrack>;
    query?: string;
    onClick?: () => void;
    isSearching?: boolean;
    hasMadeFirstSearch?: boolean;
};

export const TrackListContainer = styled.ul`
    list-style-type: none;
    padding-inline-start: 0;
    margin-left: auto;
    margin-right: auto;
    width: fit-content;
`;


function SearchTrackResultList(props: SearchTrackResultListProps) {
    const {tracks, query, onClick, isSearching, hasMadeFirstSearch} = props;

    const hasNoResults = !tracks || tracks?.length === 0;

    return (
        <TrackListContainer>

            {isSearching && (<Message>Searching...</Message>)}

            {!hasMadeFirstSearch && !query && !isSearching && (
                <li>
                    <Message>Start your search to see the results here.</Message>
                </li>
            )}


            {hasMadeFirstSearch && hasNoResults && (
                <li>
                    <Message>No results.</Message>
                </li>
            )}

            {tracks?.map(track => (
                <Track key={track.id} track={track} onClick={() => {
                    storeTrack(track.id)
                        .then(() => {
                            if (onClick) onClick();
                        });

                }}/>
            ))}

            {hasMadeFirstSearch && !isSearching && (
                <a href={`https://open.spotify.com/search/${query}`} target="_blank">
                    Keep searching in the Spotify App
                </a>
            )}
        </TrackListContainer>
    );
}

export default SearchTrackResultList;